module.exports = __webpack_public_path__ + "static/img/banner3.55971c2.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/banner3.webp
// module id = wsOS
// module chunks = 2